import DateHelper from "../../../lib/date-helper";
import Api from "../../../lib/api";
import {throttle} from "../../../lib";

export default class EventDynamicContent {
	constructor() {
		this.$dynamicContentBlocks = null;
		this.$spinners = null;
		this.$registrationButtons = null;

		this.eventTimestamp = null;
		this.eventRegistrationMode = null;

		this.eventDate = null;

		this.init();
	}

	init() {
		this.$dynamicContentBlocks = document.querySelectorAll('.dynamic-block_content');
		this.$spinners = document.querySelectorAll('.dynamic-block_spinner');
		this.$registrationButtons = document.querySelectorAll('.status-bar-btn');

		this.setEventRegistrationModeAndDate();
		this.fetchEndPostButtons();
	}

	setEventRegistrationModeAndDate() {
		return Api.get(Api.apiSiteUrl + '/feed/blog/event-registration-mode', {
			entryId: craft.page.entryId
		}).then((res) => {
			if (res.status === 'ok') {
				this.eventRegistrationMode = res.payload.eventRegistrationMode;
			}

			// Set event date
			this.setEventDatetime();

			// Set registration buttons state
			this.setRegistrationButtonsState();

			// Show dynamic content
			if (this.$dynamicContentBlocks.length) {
				this.$dynamicContentBlocks.forEach(($block) => {
					if ($block.dataset.state === 'loading') {
						$block.removeAttribute('data-state');
					}
				});
			}

			// Remove spinners
			if (this.$spinners.length) {
				this.$spinners.forEach(($spinner) => {
					$spinner.remove();
				});
			}
		});;
	}

	/**
	 * Renders event date in client's timezone,
	 * also renders timezone name
	 */
	setEventDatetime() {
		if (!craft.page.eventDate) {
			throw new Error('EventDynamicContent: eventDate is missing');
		}
		// Set event date timestamp
		this.eventTimestamp = +craft.page.eventDate * 1000;

		if (craft.page.eventCity !== 'online') {
			return;
		}

		const $eventDate = document.querySelectorAll('.event-date');
		const $eventDateExtended = document.querySelectorAll('.event-date-extended');
		const $eventDateShort = document.querySelectorAll('.event-date-short');
		const $eventDateMicro = document.querySelectorAll('.event-date-micro');
		const $timezoneFields = document.querySelectorAll('.user-timezone');

		let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		if (timezone === 'Europe/Kiev') {
			timezone = 'Europe/Kiyv';
		} else if (timezone === 'Europe/Moscow') {
			timezone = 'Europe/404';
		}

		// Set timezone view
		if ($timezoneFields.length) {
			$timezoneFields.forEach(($timezoneField) => {
				$timezoneField.textContent = timezone;
			});
		}

		if ($eventDate.length) {
			const eventDate = DateHelper.moment({
				value: this.eventTimestamp,
				pattern: 'd MMM в HH:mm'
			}).get().toLowerCase();

			$eventDate.forEach(($eventDateItem) => {
				$eventDateItem.textContent = eventDate;
			});
		}

		if ($eventDateExtended.length) {
			const eventDateExtended = DateHelper.moment({
				value: this.eventTimestamp,
				pattern: 'd MMM (EE), в HH:mm'
			}).get().toLowerCase();

			$eventDateExtended.forEach(($eventDateExtendedItem) => {
				$eventDateExtendedItem.textContent = eventDateExtended;
			});
		}

		if ($eventDateShort.length) {
			const eventDateShort = DateHelper.moment({
				value: this.eventTimestamp,
				pattern: 'd MMM'
			}).get().toLowerCase();

			$eventDateShort.forEach(($eventDateShortItem) => {
				$eventDateShortItem.textContent = eventDateShort;
			});
		}

		if ($eventDateMicro.length) {
			const eventDateShort = DateHelper.moment({
				value: this.eventTimestamp,
				pattern: 'd MMM'
			}).get().toLowerCase();

			$eventDateShort.forEach(($eventDateShortItem) => {
				$eventDateShortItem.textContent = eventDateShort;
			});
		}
	}

	setRegistrationButtonsState() {
		if (!this.$registrationButtons.length) {
			return;
		}

		const diffTimestamp = Date.now() - this.eventTimestamp;
		const twoHoursInMs = 2 * 60 * 60 * 1000;

		this.$registrationButtons.forEach(($button) => {
			if (this.eventRegistrationMode === 'disabled') {
				$button.dataset.state = 'paused';
			} else if (diffTimestamp > twoHoursInMs) {
				$button.dataset.state = 'stopped';
			}
		});
	}

	fetchEndPostButtons() {
		const $endPostButtonsPlaceholder = document.getElementById('endPostButtonsPlaceholder');
		const applicationId = costorage.get(`h_eventApplicationId_${craft.page.entryId}`);

		const params = { entryId: craft.page.entryId };

		if (applicationId) {
			params.applicationId = applicationId;
		}

		Api.get(Api.apiSiteUrl + '/feed/blog/end-post-buttons', params)
			.then((data) => {
				const payload = data.trim();

				if (payload) {
					$endPostButtonsPlaceholder.insertAdjacentHTML('afterend', payload);
					$endPostButtonsPlaceholder.remove();
				}
			});
	}
}